import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { checkUrl } from 'src/app/deployment';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(private http: HttpClient) { }

  sendContactUsEmail(image: any, name: string, email: string, subject: string, message: string) {
    
    const formData = new FormData();
    if (image.size) {
      formData.append("Image", image);
    }
    formData.append("name", name);
    formData.append("email", email);
    formData.append("subject", subject);
    formData.append("message", message);
  
    // console.log("Contact us formdata", formData);
  
    return this.http.post(checkUrl()+'/admin/contact-us', formData);
  }

}
